import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { environment } from 'src/environments/environment'
import { AuthGuardService } from '../auth/auth-guard.service'
import { ProcessAnalyticsComponent } from '../process/process-analytics/process-analytics.component'
import { ProcessManageComponent } from '../process/process-manage/process-manage.component'
import { ProcessOverviewComponent } from '../process/process-overview/process-overview.component'
import { ProcessRecordsComponent } from '../process/process-records/process-records.component'
import { RecordViewComponent } from '../process/process-records/record-view/record-view.component'
import { ProcessComponent } from '../process/process.component'
import { ChangeOrderItemsComponent } from './change-order-items/change-order-items.component'
import { MarkDeliveredComponent } from './mark-delivered/mark-delivered.component'
import { OutForDeliveryComponent } from './out-for-delivery/out-for-delivery.component'
import { PlanForDeliveryComponent } from './plan-for-delivery/plan-for-delivery.component'
import { SalesComponent } from './sales.component'

export const appRoutes = [
  {
    path: `department/${environment.config.sales.id}`,
    component: SalesComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: 'Change Order Items',
        component: ChangeOrderItemsComponent
      },
      {
        path: 'Plan For Delivery',
        component: PlanForDeliveryComponent
      },
      {
        path: 'Out For Delivery',
        component: OutForDeliveryComponent
      },
      {
        path: 'Mark Delivered',
        component: MarkDeliveredComponent
      }
    ]
  },
  {
    path: `department/${environment.config.sales.id}/process/:processId`,
    component: ProcessComponent
  },
  {
    path: `department/${environment.config.sales.id}/process/:processId/records`,
    component: ProcessRecordsComponent
  },
  {
    path: `department/${environment.config.sales.id}/process/:processId/records/:recordId`,
    component: RecordViewComponent
  },
  {
    path: `department/${environment.config.sales.id}/process/:processId/analytics`,
    component: ProcessAnalyticsComponent
  },
  {
    path: `department/${environment.config.sales.id}/process/:processId/overview`,
    component: ProcessOverviewComponent
  },
  {
    path: `department/${environment.config.sales.id}/process/:processId/manage`,
    component: ProcessManageComponent
  }
]

@NgModule({
  imports: [RouterModule.forChild(appRoutes)],

  exports: [RouterModule]
})
export class SalesRoutingModule {}
